<template>
  <router-view />
</template>
<script>
//import OfficialWebsite from '@/views/OfficialWebsite.vue';

export default {
  name: 'App',
/*  components: {
    OfficialWebsite
  }*/
}
</script>

<style>
@import './assets/styles/main.scss';

</style>
